import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {};
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  stroke: "none",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M15 12.5C14.3096 12.5 13.75 13.0597 13.75 13.75V17.5H2.5V6.25016H6.25C6.94039 6.25016 7.5 5.69062 7.5 5.00016C7.5 4.30969 6.94039 3.75016 6.25 3.75016H2.5C1.1193 3.75016 0 4.86937 0 6.25016V17.5C0 18.8806 1.1193 20 2.5 20H13.75C15.1307 20 16.25 18.8806 16.25 17.5V13.75C16.25 13.0597 15.6904 12.5 15 12.5ZM19.6339 0.365898C19.4078 0.139766 19.0955 0 18.75 0H12.5C11.8097 0 11.2502 0.559531 11.2502 1.24984C11.2502 1.94 11.8097 2.49969 12.4999 2.49969H15.7324L6.98211 11.357C6.49391 11.8451 6.49391 12.6367 6.98211 13.125C7.47031 13.6131 8.2618 13.613 8.75 13.125L17.5003 4.26742V7.5C17.5003 8.19031 18.0599 8.74984 18.7502 8.74984H18.7502C19.4405 8.74984 20 8.19031 20 7.5V1.24984C20 0.904531 19.8602 0.592031 19.6339 0.365898Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
const RedirectIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  RedirectIcon as default
};
//# sourceMappingURL=RedirectIcon.vue.es.js.map
